// extracted by mini-css-extract-plugin
export default {"section":"ChartBox_section__6q35n"};